/*
 * Copyright (c) 2026 Gabriele Bonora. Tutti i diritti riservati.
 *
 * Software proprietario. Nessuna licenza d'uso, copia, modifica o distribuzione
 * e' concessa in assenza di autorizzazione scritta del titolare dei diritti.
 * Vedere il file LICENSE nella radice del progetto.
 */
import apiClient from './client';

export const filesAPI = {
  // Le etichette dei documenti dell'impianto (libretto, conformità, garanzia...).
  // Arrivano dall'API perché cambiano con il catalogo dei prodotti: qui dentro
  // resterebbero indietro alla prima aggiunta.
  categorieDocumento: async () => {
    const { data } = await apiClient.get('/files/categorie-documento');
    return data;
  },
  listByIntervento: async (interventoId) => {
    const { data } = await apiClient.get(`/files/intervento/${interventoId}`);
    return data;
  },
  stats: async (interventoId) => {
    const { data } = await apiClient.get(`/files/stats/${interventoId}`);
    return data;
  },
  upload: async (interventoId, file, tipo, onProgress) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('intervento_id', interventoId);
    formData.append('tipo', tipo || '');
    const { data } = await apiClient.post('/files/upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      onUploadProgress: (e) => {
        if (onProgress && e.total) onProgress(Math.round((e.loaded / e.total) * 100));
      },
    });
    return data;
  },
  remove: async (id) => {
    const { data } = await apiClient.delete(`/files/${id}`);
    return data;
  },
};
